/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_MessageInputs */

const en_contact_message = /** @type {(inputs: Contact_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you have any questions or concerns, please reach out to us via our email address `)
};

/**
* | output |
* | --- |
* | "If you have any questions or concerns, please reach out to us via our email address" |
*
* @param {Contact_MessageInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_message = /** @type {((inputs?: Contact_MessageInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_MessageInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_message(inputs)
});